import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import {
  IQuiztopiyaCurriculumForAdmin,
  IQuiztopiyaSubTopicsForAdmin,
  IQuiztopiyaTopicsForAdmin,
} from '.';

export type TGetQuiztopiyaTopicsForAdmin = {
  subjectLevel: string;
  subjectCode: string;
};

export type TGetQuiztopiyaSubTopicsForAdmin = {
  topicId: string;
};

const apiDataProvider = new APIDataProvider();

export const getQuiztopiyaCurriculumsForAdmin = createAsyncThunk(
  '/admin/external/quiztopiya/curriculums',
  async () => {
    const path = `${AdminApiPaths.external}/quiztopiya/curriculums`;

    const response = await apiDataProvider.get<
      TApiResponse<IQuiztopiyaCurriculumForAdmin[]>
    >(path);

    return response.data;
  }
);

export const getQuiztopiyaTopicsForAdmin = createAsyncThunk(
  '/admin/external/quiztopiya/getTopics',
  async (data: TGetQuiztopiyaTopicsForAdmin) => {
    const path = `${AdminApiPaths.external}/quiztopiya/getTopics?subjectLevel=${data.subjectLevel}&subjectCode=${data.subjectCode}`;

    const response = await apiDataProvider.get<
      TApiResponse<IQuiztopiyaTopicsForAdmin[]>
    >(path);

    return response.data;
  }
);

export const getQuiztopiyaSubTopicsForAdmin = createAsyncThunk(
  '/admin/external/quiztopiya/getSubTopics',
  async (data: TGetQuiztopiyaSubTopicsForAdmin) => {
    const path = `${AdminApiPaths.external}/quiztopiya/getSubTopics?topicId=${data.topicId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IQuiztopiyaSubTopicsForAdmin[]>
    >(path);

    return response.data;
  }
);
